import { Observable } from 'knockout'

export interface JSONPersonTiny {
    PersonId?: string
    FullName?: string
    ImageURL?: string
}

export default class PersonTiny {
    personId: Observable<string | undefined>
    fullName: Observable<string | undefined>
    imageURL: Observable<string | undefined>

    constructor(config?: JSONPersonTiny) {
        this.personId = ko.observable(config?.PersonId);
        this.fullName = ko.observable(config?.FullName);
        this.imageURL = ko.observable(config?.ImageURL);
    }

    update(config: JSONPersonTiny) {
        this.personId(config.PersonId);
        this.fullName(config.FullName);
        this.imageURL(config.ImageURL);
    }
}